export default __webpack_public_path__ + "static/media/jogger2.14a7ce89.png";